import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import ReactSwipe from 'react-swipe';
import theme from 'ui/styles/theme';
import getRelativeUrl from 'utils/getRelativeUrl';
import { Link } from 'react-router-dom';

export default class JpnHero extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dotPos: '',
            slideIndex: 0,
            isMobile: false
        }
    }

    componentDidMount = () => {
        //Detect if mobile
        this.detectMobile();
    }

    detectMobile = () => {
        const width = window.innerWidth
        const isMobile = width <= theme.grid.breakpoints.lg
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile })
        }
        this.dotPosition(isMobile);

    }
    transition = () => {
        this.setState({ slideIndex: this.reactSwipeEl.swipe.getPos() })
    }

    //Get the position of a React element
    getSwipePosition = (element) => {
        return element.getBoundingClientRect();
    }

    dotPosition = (x) => {
        //Get the position of ReactSwipe component
        let posSwipe = this.getSwipePosition(this.reactSwipeEl.containerEl);
        //Get the position of dot container
        let posDotCont = this.getSwipePosition(this.dotCont);
        if (x) {
            //Set state to the difference of heights so it is always at the top
            this.setState({ dotPos: 0 - posDotCont.height + posDotCont.height * 2 });
            console.log('true')
        } else {
            console.log(this.state.isMobile)
            //Set state to the difference of heights so it is always at the bottom
            this.setState({ dotPos: posSwipe.height - posDotCont.height * 2 });
        }

    }

    render() {
        const { bgcolor, start, pictures } = this.props

        const { dotPos, slideIndex } = this.state


        const swipeOptions = {
            continuous: true,
            startSlide: start,
            transitionEnd: this.transition,
            auto: 3000
        }

        //Refs
        let reactSwipeEl;
        let dotCont;


        return (
            <Wrapper bgcolor={bgcolor}>
                <HeroWrapper>
                    <ReactSwipe
                        swipeOptions={swipeOptions}
                        ref={el => (this.reactSwipeEl = el)}
                    >
                        {pictures.map((item, index) =>
                            <ImgContainer key={index} to={getRelativeUrl(item.url.link)}>
                                {item.top_text &&
                                    <Text>{item.top_text}</Text>
                                }
                                <Image picture={item.image.sourceUrl} />
                                {item.bottom_text_jpn &&
                                    <BtmText>
                                        <p className={"bottom-text"}>{item.bottom_text_jpn}</p>
                                        <TextButton>
                                            <span>{item.bottom_text_eng}</span>
                                            {item.button_text_japanese &&
                                                <BannerButton>
                                                    <p>{item.button_text_japanese}</p>
                                                    <p>{item.button_text_english}</p>
                                                </BannerButton>
                                            }
                                        </TextButton>
                                    </BtmText>
                                }
                            </ImgContainer>
                        )}
                    </ReactSwipe>
                    <DotContainer position={dotPos} innerRef={el => (this.dotCont = el)}>
                        {pictures.map((item, index) =>
                            <Dot key={index} color={index === slideIndex ? "0, 153, 77, 1" : "173, 207, 237, 0.4"} onClick={() => this.reactSwipeEl.slide(index, 300)}></Dot>
                        )}
                    </DotContainer>
                </HeroWrapper>
            </Wrapper>
        )
    }
}


const Text = styled.p`
position: absolute;
top: 16%;
left: 5%;
color: white;
`

const TextButton = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: column;
align-items: flex-start;

${media.md`
flex-direction: row;
`}
`

const BannerButton = styled.button`
font-size: min(3vw, 22px) !important;
padding: 0px;
height: 50%;
border-radius: 100px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background-color: #00994c;
width: 30%;
text-align: center;
color: white;
cursor: pointer;
text-transform: uppercase;
text-decoration: none;
margin-bottom: 0;
border-style: none;
margin-bottom: 10px;
min-width: 200px;

:hover {
    opacity: 0.9;
    color: white;
}

p{ 
    color: white !important;
}

${media.xl`
width: 18%;
`}
`

const BtmText = styled.div`
font-family: "Noto Sans JP", "Helvetica Neue", Helvetica, YuGothic, "Hiragino Kaku Gothic ProN", Meiryo, sans-serif;
width: 90%;
position: absolute;
top: 43%;
left: 5%;
background: rgba(255, 255, 255, .8);
text-align: left;
padding-left: 10px;
padding-right: 10px;

.bottom-text {
    font-size: 2em;
}

${media.md`
top: 84%;
font-size: 1.5vw;
`}

${media.lg`
top: 54%;
`}

${media.xl`
top: 63%;
`}

p{

    font-weight: 500;
    color: #004077;
    text-align: left;
    margin-bottom: 0;
}

span{
    margin-bottom: 20px;
    text-align: left;
    color: #004077;
}
`
const DotContainer = styled.div`
display: flex;
position: absolute;
left: 50%;
transform: translateX(-50%);
top: ${props => props.position}px;
`
const Dot = styled.div`
display: block;
margin: 0 0.5em;
width: 0.7em;
height: 0.7em;
background: rgba(${props => props.color});
border-radius: 100px;
cursor: pointer;
`
const ImgContainer = styled(Link)`
position: relative;
text-align: center;
`

const Image = styled.div`
// background: linear-gradient(rgba(0,64,119,0) 0%,  rgba(0,64,119,0.8) 90%),url(${props => props.picture}) center / cover;
background: url(${props => props.picture}) center / cover;
background-repeat: no-repeat;
height: 90vw;
width: 100%;
background-position: center;
background-color: white;

${media.lg`
height: 30vw;
background-color: initial;
`}
`

const Wrapper = styled.div`
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
margin-top: 79px;

${media.lg`
margin-top: 79px;
`}
`
const HeroWrapper = styled(Container)`
margin: 0;
width: 100%;
padding: 0 0px;
max-width: 100%;

${media.lg`
padding: 0 0%;
max-width: 80%;
margin: auto;
`}
`
const Heading = styled.h2`
font-size: 35px !important;
font-weight: 350 !important;
line-height: 1.2 !important;
margin-bottom: 0px !important;
`

const ProductName = styled.div`
${media.md`
margin-top: 5px;
`}

`




// WEBPACK FOOTER //
// ./src/ui/components/modules/JpnHero/index.js